module.exports = __webpack_public_path__ + "media/application/images/icons/dark-plus-inverse-f6b240aa443bdcd6e68b216fb63e66c3.svg";